import { useState } from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { Link, NavLink, Outlet } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { navigationSchema } from "@eaf/contracts";
import { publicApi } from "../api/client";
import { useAuth } from "../auth/auth-context";

export function Layout() {
  const [expanded, setExpanded] = useState(false);
  const navigation = useQuery({
    queryKey: ["navigation"],
    queryFn: () => publicApi("/content/navigation", navigationSchema)
  });
  const auth = useAuth();
  return (
    <div className="site-shell">
      <Navbar
        expand="lg"
        expanded={expanded}
        onToggle={setExpanded}
        className="site-nav"
        data-bs-theme="dark"
      >
        <Container>
          <Navbar.Brand as={Link} to="/">
            EDMUND ALAN FAIN<span>Original Art Collection</span>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="primary-navigation" />
          <Navbar.Collapse id="primary-navigation">
            <Nav className="ms-auto" onSelect={() => setExpanded(false)}>
              {(
                navigation.data?.items ?? [
                  { label: "Home", href: "/", order: 1 },
                  { label: "Gallery", href: "/gallery", order: 2 },
                  { label: "Biography", href: "/biography", order: 3 }
                ]
              ).map((item) => (
                <Nav.Link key={item.href} as={NavLink} to={item.href} end={item.href === "/"}>
                  {item.label}
                </Nav.Link>
              ))}
              {auth.state === "authenticated" &&
              auth.currentUser?.permissions.some((permission) =>
                ["artwork.create", "artwork.update"].includes(permission)
              ) ? (
                <Nav.Link as={NavLink} to="/curator">
                  Curator
                </Nav.Link>
              ) : null}
              <Nav.Link as={NavLink} to="/admin">
                {auth.state === "authenticated" ? "Administration" : "Sign in"}
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <div id="main-content">
        <Outlet />
      </div>
      <footer className="site-footer">
        <Container>
          <p>
            For sales and licensing inquiries, contact{" "}
            <a href="mailto:sales@edmundalanfain.com">sales@edmundalanfain.com</a>.
          </p>
          <p>1201 6th Ave. W, Ste. 100, Unit #A646, Bradenton, FL 34205</p>
          <small>Copyright © Fain’s Fine Art</small>
        </Container>
      </footer>
    </div>
  );
}
